import { render } from "./RiSds.vue?vue&type=template&id=0afe8af6"
import script from "./RiSds.vue?vue&type=script&lang=js"
export * from "./RiSds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSds.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0afe8af6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0afe8af6', __exports__)) {
    api.reload('0afe8af6', __exports__)
  }
  
  module.hot.accept("./RiSds.vue?vue&type=template&id=0afe8af6", () => {
    api.rerender('0afe8af6', render)
  })

}


export default __exports__